module.exports = __webpack_public_path__ + "HelveticaLight.184bb8eeeab316d1bef1.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-netsul/src/app/@theme/fontes/Helvetica/HelveticaLight.woff2
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLight.woff2
// module chunks = styles